(function ($) {

    "use strict";

    $(function () {

        global.$ = require('jquery');

        $('[data-toggle="tooltip"]').tooltip();
        let options = [];
        $('.dropdown-checkboxes .dropdown-menu div').on('click', function (event) {

            let $target = $(event.currentTarget),
                val = $target.attr('data-value'),
                $inp = $target.find('input'),
                idx = options.indexOf(val);
            //console.log(idx);
            if (idx > -1) {
                options.splice(idx, 1);
                setTimeout(function () {
                    $inp.prop('checked', false)
                }, 0);
            } else {
                options.push(val);
                setTimeout(function () {
                    $inp.prop('checked', true)
                }, 0);
            }

            $(event.target).blur();

            //console.log(options);
            return false;
        });
    });

    let blockElements = document.getElementById("block-elements");
    if (blockElements !== null) {
        $('.map').maphilight();

        $('.pointer').hover(
            function () {
                $(".pointer[data-number=" + $(this).data('number') + "]").addClass('hover');
                $("map area[data-number=" + $(this).data('number') + "]").mouseover();
            },
            function () {
                $(".pointer[data-number=" + $(this).data('number') + "]").removeClass('hover');
                $("map area[data-number=" + $(this).data('number') + "]").mouseout();
            }
        );
        $('map area').hover(
            function () {
                $(".pointer[data-number=" + $(this).data('number') + "]").addClass('hover');
            },
            function () {
                $(".pointer[data-number=" + $(this).data('number') + "]").removeClass('hover');
            }
        );
    }


    let pointerCreateForm = document.getElementById("pointer-create-form");
    if (pointerCreateForm !== null) {
        let moveLeft = -48,
            moveDown = -50,
            ofs = 39,
            crosshair = $("#crosshair");
        $('img.map.pointers')
            .hover(function (e) {
                $('#crosshair').show()
                    .css('top', e.pageY + moveDown)
                    .css('left', e.pageX + moveLeft)
                    .appendTo('body');
            }, function () {
                $('#crosshair').hide();
            })
            .mousemove(function (e) {
                crosshair.css('top', e.pageY).css('left', e.pageX - ofs);
                if ($('[name="element_id"]').is(':checked')) {
                    crosshair.removeClass('empty').html($('[name="element_id"]:checked').parent().parent().parent().find('.number').html());
                } else {
                    crosshair.addClass('empty').html('╳ ' + $('#block-elements').data('empty'));
                }
            })
            .click(function (event) {
                if ($('[name="element_id"]:checked').val() !== 'undefined') {
                    $('[name="x"]').val(Math.round(event.pageX - $(this).offset().left - 39, 0));
                    $('[name="y"]').val(Math.round(event.pageY - $(this).offset().top, 0));
                    submitForm($('#pointer-create-form'));
                }
            });
    }

    let shapeCreateForm = document.getElementById("shape-create-form");
    if (shapeCreateForm !== null) {
        $('a.save-shape-button')
            .click(function (event) {
                if ($('[name="element_id"]:checked').val() !== 'undefined') {
                    let count = $('[name="coords"]').val().split(",").length - 1, shape;
                    switch (count) {
                        case 0:
                        case 1:
                            shape = false;
                            break;
                        case 2:
                            shape = 'circle';
                            break;
                        case 3:
                            shape = 'rect';
                            break;
                        default:
                            shape = 'poly';
                    }
                    if (shape !== false) {
                        $('[name="shape"]').val(shape);
                        submitForm($('#shape-create-form'));
                    } else {
                        alert('Неверный контур')
                    }
                } else {
                    alert('Не выбрана деталь')
                }
            });
    }

    $('html').on('click', '.search_wrapper', (function(){
        $(this).hide();
    }));
    $('html').click(function(){
        $('.search_wrapper').hide();
    });


    $(document).ready(function () {
        $('.c-navigation-menu-button').click(function(I){
            $('.menu-left').toggle();
            }
        )
        $('.toggle-menu').click(function(I){
            $('#'+$(this).data('menu')).toggle();
            if(window.innerWidth > 767) {
                $('.menu-left-small-second').toggle();
            }else{
                $('.menu-left').toggle();
            }
            }
        )

        let countKeys=0;
        $("#review_message").keyup(function(I){
            countKeys++;
            switch(I.keyCode) {
                // игнорируем нажатия
                case 13:  // enter
                case 27:  // escape
                case 38:  // стрелка вверх
                case 40:  // стрелка вниз
                    break;

                default:
                    if(countKeys==7){
                        let antibotcode=$('#antibotcode').val();
                        axios
                            .post('/antibot/getcode', {"antibotcode": antibotcode})
                            .then((response) => {
                                if(response.data != 'error') {
                                    $('#antibotcontorlcode').val(response.data)
                                }

                            })
                            .catch((error) => {
                                this.status = 'Error:' + error;
                            });
                    }
                    break;
            }
        });

        $('.rating.control-mode .fa').bind('click', function() {
            var $this = $(this);
            $this
                .nextAll()
                .removeClass('fa-rate');
            $this
                .addClass('fa-rate')
                .prevAll()
                .addClass('fa-rate');
            rateCounter();
        });

        function rateCounter(){
            $('.rating').each(function(){
                var $this = $(this),
                    _counter = $this.find('.fa-rate').length;

                if(_counter){
                    $this.find('input.rate-counter').val(0);
                }
                $this.find('input.rate-counter').val(_counter);
            });
            return this;
        }
        rateCounter();

        let containerSpecifications = document.getElementById("container-specifications");
        
        if (containerSpecifications !== null) {
            let renderSpecificationsList = function (data) {
             if (data !== undefined) {
                    containerSpecifications.innerHTML = null;
                    containerSpecifications.innerHTML += data.data;
                    
                }
            };
            
            let drawSpecifications = function () {

                let action = $(containerSpecifications).data('action');
                let screenwidth = $(window).innerWidth();
                axios
                    .get(action+ '?screenwidth=' + screenwidth)
                    .then((response) => {
                        renderSpecificationsList(response);
                        $('#loading-data').remove();

                        objectManager.add(response);
                        
                    })
                    .catch((error) => {

                    });
            };

         drawSpecifications();
        }
    
    
        let containerAddresses = document.getElementById("container-addresses");
        if (containerAddresses !== null) {

            let renderAddressesList = function (data) {
                if (data.features !== undefined) {
                    containerAddresses.innerHTML = null;
                    for (let key in data.features) {
                        //containerAddresses.innerHTML += data.features[key].properties.balloonContentBodyList;
                    }
                }
            };

            let drawAddresses = function () {

                let el = $(containerAddresses),
                    region = $('[name="filter[region_id]"]').find('option:selected').val(),
                    action = el.data('action');
                let checked = [];
                $('[name="filter[authorization_type][]"]').each(function (i, e) {
                    if (e.checked) {
                        checked.push('filter[authorization_type][]=' + this.value)
                    }
                });
                $('[name="filter[roles][]"]').each(function (i, e) {
                    if (e.checked) {
                        checked.push('filter[roles][]=' + this.value)
                    }
                });

                axios
                    .get(action + '/' + region + '?' + checked.join('&'))
                    .then((response) => {
                        $('#row-count').html(response.data.data.found);
                        renderAddressesList(response.data.data);
                        $('#loading-data').remove();

                        myMap.geoObjects.remove(objectManager);
                        objectManager.removeAll();
                        objectManager.add(response.data.data);
                        myMap.geoObjects.add(objectManager);
                        let bounds = myMap.geoObjects.getBounds();
                        myMap.setBounds(bounds, {checkZoomRange: true}).then(function () {
                            if (myMap.getZoom() > 10) myMap.setZoom(10);
                        });


                    })
                    .catch((error) => {

                    });
            };

            let myMap, objectManager;

            ymaps.ready(function () {
                myMap = new ymaps.Map('addresses-map', {
                    center: [55.76, 37.64],
                    zoom: 9,
                    controls: ['zoomControl', 'typeSelector', 'fullscreenControl']
                }, {
                    searchControlProvider: 'yandex#search'
                });

                objectManager = new ymaps.ObjectManager({
                    clusterize: false,
                    gridSize: 64,
                    clusterIconLayout: "default#pieChart"
                });
                myMap.geoObjects.add(objectManager);
                drawAddresses();

            });
        }
    });


    let summernote = document.getElementById("summernote");
    if (summernote !== null) {
        $('.summernote').summernote({
            height: 150,
            lang: 'ru-RU',
            toolbar: [
                // [groupName, [list of button]]

                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['font', ['strikethrough', 'superscript', 'subscript']],
                ['fontname', ['fontname']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['height', ['height']],
                ['insert', ['picture', 'link', 'table']],
                ['misc', ['undo', 'redo', 'codeview']],
            ],
            fontNames:['Myriad Pro','Open Sans','Arial','Times New Roman','Verdana']
        });
    }

    let sortableImageList = document.getElementsByClassName("sort-list");
    if (sortableImageList.length > 0) {
        for (let i in sortableImageList) {
            if (sortableImageList.hasOwnProperty(i)) {
                Sortable.create(sortableImageList[i], {
                    group: 'items',
                    animation: 100,
                    // Changed sorting within list
                    onUpdate: function (/**Event*/evt) {
                        let result = [],
                            i,
                            list = evt.item.parentElement,
                            action = list.getAttribute('data-target'),
                            elements = list.children;
                        for (i = 0; i < elements.length; i++) {
                            result.push(elements[i].getAttribute('data-id'));
                        }

                        axios
                            .put(action, {sort: result})
                            .catch((error) => {
                                console.log(error);
                            });

                    },

                });
            }
        }
    }

    let sortableImagesList = document.getElementById("sort-list");
    if (sortableImagesList !== null) {
        Sortable.create(sortableImagesList, {
            group: 'items',
            animation: 100,
            // Changed sorting within list
            onUpdate: function (/**Event*/evt) {
                let result = [],
                    i,
                    list = evt.item.parentElement,
                    action = list.getAttribute('data-target'),
                    elements = list.children;
                for (i = 0; i < elements.length; i++) {
                    result.push(elements[i].getAttribute('data-id'));
                }
                //console.log(action);
                axios
                    .put(action, {sort: result})
                    .catch((error) => {
                        console.log(error);
                    });

            },

        });
    }

    let adminPartsFieldset = document.getElementById("admin-parts-fieldset");
    if (adminPartsFieldset !== null) {
        let boiler_search = $('#product_id'),
            parts_search = $('#parts_search');
        parts_search.select2({
            theme: "bootstrap4",
            ajax: {
                url: '/api/products/repair',
                dataType: 'json',
                // delay: 200,
                data: function (params) {
                    return {
                        'filter[search_part]': params.term,
                        'filter[search_product]': boiler_search.val(),
                    };
                },
                processResults: function (data, params) {
                    return {
                        results: data.data,
                    };
                }
            },
            minimumInputLength: 3,
            templateResult: function (product) {
                if (product.loading) return "...";
                //return product.name;
                //if(product.enabled) return product.name;
                //let markup = product.name + ' (' + product.sku + ')';
                let markup = product.name + ' (' + product.sku + ')';
                return markup;
            },
            templateSelection: function (product) {
                return product.name;
            },
            escapeMarkup: function (markup) {
                return markup;
            }
        });
    }

    let mountingSourceIdExists = document.getElementById("mounting_source_id");
    if (mountingSourceIdExists !== null) {
        mountingSourceIdExists.addEventListener('change', function (e) {
            let element = e.target.parentElement.nextElementSibling;
            if (e.target.options.selectedIndex === 4) {
                element.classList.remove('d-none');
                element.classList.add('required');
                element.firstElementChild.nextElementSibling.required = true;
            } else {
                element.classList.add('d-none');
                element.classList.remove('required');
                element.firstElementChild.nextElementSibling.required = false;
            }
        });
    }

    let _modal = $('#form-modal'),
        btnOk = _modal.find('.btn-ok'),
        btnDelete = _modal.find('.btn-delete'),
        form;

    let addToCartModal = $('#confirm-add-to-cart');
    addToCartModal.appendTo("body");

    let manageButtonData = function (element) {
        let label = element.data('label'),
            btnOk = element.data('btnOk'),
            message = element.data('message'),
            btnDelete = element.data('btnDelete'),
            btnCancel = element.data('btnCancel');
        form = element.data('form');
        if (message !== undefined) {
            _modal.find('.modal-body').html(message);
        }
        if (label !== undefined) {
            _modal.find('.modal-title').html(label);
        }
        if (btnOk !== undefined) {
            _modal.find('.btn-ok').html(btnOk);
        } else {
            _modal.find('.btn-ok').hide();
        }
        if (btnCancel !== undefined) {
            _modal.find('.btn-cancel').html(btnCancel);
        } else {
            _modal.find('.btn-cancel').hide();
        }
        if (btnDelete !== undefined) {
            _modal.find('.btn-delete').html(btnDelete);
        } else {
            _modal.find('.btn-delete').hide();
        }
    };


    $(".datetimepickerfull")
        .datetimepicker({
            locale: 'ru',
            inline: false,
            sideBySide: true,
            useCurrent: false
        });


    $(".datetimepicker")
        .datetimepicker({
            locale: 'ru',
            //format: 'L',
            format: 'DD.MM.YYYY',
            useCurrent: false,
            pickTime: false
        });

    $("#datetimepicker_date_from")
        .on("change.datetimepicker", function (e) {
            $('#datetimepicker_date_to').datetimepicker('minDate', e.date);
        });

    $("#datetimepicker_date_to")
        .on("change.datetimepicker", function (e) {
            $('#datetimepicker_date_from').datetimepicker('maxDate', e.date);
        });


    $('body')
        .on('click', '.btn-row-delete:not(:disabled)', function (e) {
            manageButtonData($(this));
        })
 		  .on('click', '.dynamic-modal-form-card', function (e) {
             var select = $(this),
            option = select.find('option:selected');
				var action = select.data('formAction');
				$.ajax({
                type: 'GET',
                url: action,
                data: {},
                success: function success(data) {
                    _modal.find('.modal-body').html(data);
                    manageButtonData(select);
                    $('.datetimepicker').datetimepicker({ locale: 'ru', format: 'L', useCurrent: false });
                    _modal.modal('show');
                    _modal.mask_phones();
                }
            });
        
        })
		  .on('click', '.long-wait', function (e) {
             alert('Внимание! Ожидание загрузки может быть долгим. Нажмите ОК и ждите полной загрузки. Не нажимайте повторно.')
             $('#wait_window').removeClass('d-none');
        
        })
		  .on('click', '.append-block', function (e) {
              var action = $(this).data('formAction');
              let dst = $('#'+$(this).data('dst'));
            	$.ajax({
                type: 'GET',
                url: action,
                data: {},
                success: function success(data) {
                    dst.html(data);
                }
            });

        })
		  .on('click', '.dynamic-modal-form-card-lg', function (e) {
             var select = $(this),
            option = select.find('option:selected');
            $('.modal-dialog').addClass('modal-900');
				var action = select.data('formAction');
				$.ajax({
                type: 'GET',
                url: action,
                data: {},
                success: function success(data) {
                    _modal.find('.modal-body').html(data);
                    manageButtonData(select);
                    $('.datetimepicker').datetimepicker({ locale: 'ru', format: 'L', useCurrent: false });
                    _modal.modal('show');
                }
            });

        })
		.on('click', '.dynamic-modal-form-button', function (e) {
                        
                           $('.modal-dialog').addClass('modal-900');
                            var action = $(this)[0].dataset.formAction;
                             $.ajax({
                                 type: 'GET',
                                 url: action,
                                 data: {},
                                 success: function success(data) {
                                     _modal.find('.modal-body').html(data);
                                     manageButtonData($(this));
                                     $('.datetimepicker').datetimepicker({ locale: 'ru', format: 'L', useCurrent: false });
                                     _modal.modal('show');
                                 }
                             });
                        
                    })
                    
        .on('change', '.dynamic-modal-form', function (e) {
            let select = $(this), option = select.find('option:selected');
            //if (option.val() === 'add-option') {}

            if (option.val() === 'load') {
                select.val('');
                let action = select.data('formAction');
                $.ajax({
                    type: 'GET',
                    url: action,
                    data: {},
                    success: function (data) {
                        _modal.find('.modal-body').html(data);
                        manageButtonData(select);
                        $('.datetimepicker').datetimepicker({locale: 'ru', format: 'L', useCurrent: false});
                        _modal.modal('show')
                    }
                })
            }
        })

        .on('click', '.file-type-upload-sound', function (e) {
            let
                _this = this,
                form = $(_this).closest('form'),

                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                list = $($(_this).data('list')),
                multiple = $(_this).data('multiple'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    form.find('.form-group').removeClass('is-invalid');
                    if (multiple === 0) {
                        list.html(response.data.file);
                    } else {
                        list.append(response.data.file);
                    }
                })
                .catch((error) => {
                    form.find('.form-group').addClass('is-invalid');
                    $.each(error.response.data.errors.path, function (name, error) {
                        form.find('.invalid-feedback').html(error);
                    });
                    //console.log();
                }).then(() => {

                  $(".file-type-upload").prop('disabled', false);
            
                });
                $(".file-type-upload").prop('disabled', true);
            e.preventDefault();
            
        })

        .on('click', '.file-type-upload', function (e) {
            let
                _this = this,
                form = $(_this).parents('form'),

                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                list = $($(_this).data('list')),
                multiple = $(_this).data('multiple'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    form.find('.form-group').removeClass('is-invalid');
                    if (multiple === 0) {
                        list.html(response.data.file);
                    } else {
                        list.append(response.data.file);
                    }
                })
                .catch((error) => {
                    form.find('.form-group').addClass('is-invalid');
                    $.each(error.response.data.errors.path, function (name, error) {
                        form.find('.invalid-feedback').html(error);
                    });
                    //console.log();
                }).then(() => {
                    
                  form.find('#downloadbar').addClass('d-none');
            
                });
                form.find('#downloadbar').removeClass('d-none');
            e.preventDefault();
            
        })
        .on('click', '.file-upload-button-sound', function (e) {
            let
                form = $(this).closest('form'),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                slide_random = form.find('[name="slide_random"]').val(),
                preview = form.data('preview'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);
            fd.append('preview', preview);
            fd.append('slide_random', slide_random);
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    parseData(response.data)
                })
                .catch((error) => {
                    console.log();
                }).then(() => {
                    
                  form.find('#downloadbar').addClass('d-none');
            
                });
                
                form.find('#downloadbar').removeClass('d-none');
                
            e.preventDefault();
        })
        .on('click', '.file-upload-button', function (e) {
            let
                form = $(this).parents('form'),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                preview = form.data('preview'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);
            fd.append('preview', preview);
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    parseData(response.data)
                })
                .catch((error) => {
                    console.log();
                }).then(() => {
                    
                  form.find('#downloadbar').addClass('d-none');
            
                });
                form.find('#downloadbar').removeClass('d-none');
                
            e.preventDefault();
        })
        .on('change', '.file-upload', function (e) {
            let form = $(this).closest('form');
            let fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                list = $($(this).data('list')),
                multiple = $(this).data('multiple'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);

            axios
                .post(action, fd)
                .then((response) => {
                    form.find('.form-group').removeClass('is-invalid');
                    if (multiple === 0) {
                        list.html(response.data.file);
                    } else {
                        list.append(response.data.file);
                    }
                    $(this).val('')
                })
                .catch((error) => {

                }).then(() => {

                form.find('#downloadbar').addClass('d-none');

            });
            form.find('#downloadbar').removeClass('d-none');
        })
        .on('change', '.upload-input', function (e) {
            let form = $(this).closest('form');
            let fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                type_id = form.find('[name="type_id"]').val(),
                storage = form.find('[name="storage"]').val(),
                list = $($(this).data('list')),
                multiple = $(this).data('multiple'),
                action = form.attr('action');
            fd.append('path', path);
            fd.append('type_id', type_id);
            fd.append('storage', storage);

            axios
                .post(action, fd)
                .then((response) => {
                    parseData(response.data);
                    $(this).val('')
                })
                .catch((error) => {

                }).then(() => {

                form.find('#downloadbar').addClass('d-none');

            });
            form.find('#downloadbar').removeClass('d-none');
        })
        .on('click', '.btn-delete', function (e) {
            if ($(form) !== undefined) {
                submitForm($(form), function () {
                    $(_modal).modal('hide');
                });
                //form.submit();
            }
        })
        .on('click', '.add-message-button', function (e) {
            let form = $(this).parents('form');
            if ($(form) !== undefined) {
                submitForm($(form), function () {
                    form[0].reset();
                    form.find('.is-invalid').removeClass('is-invalid');
                });
            }
            e.preventDefault();
        })
        .on('change', '#change-user-logo', function () {

            let
                form = $(this).parents('form'),
                logo = $('#user-logo'),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                storage = form.find('[name="storage"]')[0].value,
                action = form.attr('action');
            fd.append('path', path);
            fd.append('storage', storage);
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: action,
                type: 'POST',
                data: fd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    logo.attr('src', response.src);
                },
            });
        })
        .on('click', '.downloadbar-upload-button-presentation_slide', function () {
            let
                form = $(this).closest('form'),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                storage = form.find('[name="storage"]')[0].value,
                slide_random = form.find('[name="slide_random"]')[0].value,
                action = form.attr('action');
            fd.append('path', path);
            fd.append('storage', storage);
            fd.append('slide_random', slide_random);
            axios.defaults.timeout = 30000;
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    resp = parseData(response.data);
                }
                )
                .catch((error) => {
                    console.log();
                }).then(() => {
                    
                  form.find('#downloadbar').addClass('d-none');
            
                });
                form.find('#downloadbar').removeClass('d-none');
        })
        
        .on('click', '.image-upload-button', function () {
            let
                form = $(this).parents('form'),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                storage = form.find('[name="storage"]')[0].value,
                action = form.attr('action');
            fd.append('path', path);
            fd.append('storage', storage);
            $(".image-upload-button").prop('disabled', true);
            axios
                .post(action, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    $(".image-upload-button").prop('disabled', false);

                   resp = parseData(response.data);

                })
                .catch((error) => {
                    // form.find('.form-group').addClass('is-invalid');
                    // $.each(error.response.data.errors.path, function (name, error) {
                    //     form.find('.invalid-feedback').html(error);
                    // });
                    console.log(error.response.data);
                }).then(() => {
                setTimeout(() => {   $(".image-upload-button").prop('disabled', false); }, 1000);

            
                });
            //submitForm($(this).parents('form'));

           
        })
        .on('click', '.image-upload', function () {

            let
                form = $(this).parents('form'),
                list = form.next(),
                fd = new FormData(),
                path = form.find('[name="path"]')[0].files[0],
                storage = form.find('[name="storage"]')[0].value,
                action = form.attr('action');
            fd.append('path', path);
            fd.append('storage', storage);
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: action,
                type: 'POST',
                data: fd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    list.append(response.image);
                },
            });
            $(".image-upload").prop('disabled', true);
            setTimeout(() => {  $(".image-upload").prop('disabled', false); }, 4000);
        })
        .on('click', '.participant-add', function () {

            let list = $('#participants-list'),
                action = $(this).data('action');

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: action,
                type: 'GET',
                dataType: 'html',
                contentType: false,
                processData: false,
                success: function (response) {
                    list.append(response);
                },
            });
        })
        .on('click', '.save-spec', function () {
            let spec_rel_id = $(this).data('sr');
            let spec_id = $(this).data('specid');
            let product_id = $(this).data('productid');
            let spec_rel_value = $('#spec_'+$(this).data('sr')).val();
            axios
                .post('/admin/specs/update-rel', {"sr_id":spec_rel_id,"sr_value":spec_rel_value,"spec_id":spec_id,"product_id":product_id})
                .then((response) => { parseData(response.data);})
                .catch((error) => {alert(errors);});
        })
        .on('change', '.edit-specs', function () {
            let spec_rel_id = $(this).data('sr');
            let spec_id = $(this).data('specid');
            let product_id = $(this).data('productid');
            let spec_rel_value = $('#spec_'+$(this).data('sr')).val();
            axios
                .post('/admin/specs/update-rel', {"sr_id":spec_rel_id,"sr_value":spec_rel_value,"spec_id":spec_id,"product_id":product_id})
                .then((response) => { parseData(response.data);})
                .catch((error) => {alert(errors);});
        })
        .on('change', '.autosave-checkbox', function () {
            let form_id = $(this).data('form');
            let route = $(this).data('route');
            let form_data = new FormData();

            if(typeof form_id != 'undefined') {
                form_data = new FormData(document.forms[form_id]);
            }else{
                form_data.append($(this).prop('name'), $(this).prop('checked'));
            }
            console.log(route);
            axios
                .post(route, form_data)
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {
                    alert(errors);
                });

        })
        .on('click', '.save-form', function () {
            let form_id = $(this).data('form');
            let route = $(this).data('route');
            let method = $(this).data('method');
            let form_data = new FormData(document.forms[form_id]);
            $('.wait_div').removeClass('d-none');

            axios
                .post(route, form_data)
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {
                    alert(errors);
                });

        })
        .on('click', '.get-form-row', function () {
            let route = $(this).data('route');
            let targetBlock= $('#'+$(this).data('targetblock'));
            axios
                .get(route)
                .then((response) => {
                    targetBlock.append(response.data);
                })
                .catch((error) => {alert(errors);});
        })
        .on('click', '.agree-cookies', function () {
            axios
                .get('/status?agree_cookies=1')
                .then((response) => {
                    $("#cookies_block").remove();
                })
                .catch((error) => {alert(errors);});
        })

        .on('click', '#send_sms', (function () {

            let form_data = new FormData(document.forms["register_form"]);
            axios
                .post("/get-sms-code", form_data)
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {

                });
        }))

        .on('click', '#reset_sms', (function () {

            let form_data = new FormData(document.forms["register_form"]);
            axios
                .post("/password/reset", form_data)
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {
                });
        }))
        .on('click', '#check_sms_ur', (function () {

            let form_data = new FormData(document.forms["attach_user"]);
            axios
                .post("/user-relations/attach-user", form_data)
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {

                });
        }))
        .on('click', '.delete-authorization-request-role', (function () {

            axios
                .post("/authorizations/delete-role", {'relrole':$(this).data('role')})
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {

                });
        }))
        .on('click', '#send_sms_ur', (function () {

            axios
                .post("/get-sms-code-ur", {'phone':$('#phone').val()})
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {

                });
        }))
        .on('click', '.expand-btn', (function () {
            $('.expand-block').addClass('d-none');
            $($(this).data('expand')).toggleClass('d-none');
        }))
        .on('change', '.equipment_filter', (function () {
            var select = $(this),
            option = select.find('option:selected');
            axios
                .post("/equipments/products-items", {'equipment_id':option.val()})
                .then((response) => {
                    $('#'+$(this).data('products')).html(response.data);
                })
                .catch((error) => {
                    alert(error)
                });
            axios
                .post("/equipments/difficulities", {'equipment_id':option.val()})
                .then((response) => {
                    $('#repair_difficulity_id').html(response.data);
                })
                .catch((error) => {
                    alert(error)
                });
        }))
        .on('click', '.delete-item-ppr', (function () {
            axios
                .get("/partner-plus-reports/"+$(this).data('report')+"/delete-item/"+$(this).data('item'))
                .then((response) => {
                    parseData(response.data);
                })
                .catch((error) => {
                    alert(error)
                });
        }))
        .on('keyup', '.user_search_partner', (function(I){
                var field_id = $(this)[0].dataset.fieldid;
                var field_second = $(this)[0].dataset.secondfield;
                let suggest_count = 0;
                let input_initial_value = '';

                switch(I.keyCode) {
                    // игнорируем нажатия
                    case 13:  // enter
                    case 27:  // escape
                    case 38:  // стрелка вверх
                    case 40:  // стрелка вниз
                        break;

                    default:
                        $(this).attr('autocomplete','off');
                        $('#'+field_second).val('');
                        if($(this).val().length>3){
                            let region_id;
                            input_initial_value = $(this).val();
                            let str=$(this).val();
                            if($(this)[0].dataset.filterRegion==1) {
                                region_id=$('#region_id').val();
                            } else {
                                region_id='';
                            }
                            $('.search_wrapper').hide();

                            $.get("/api/companies", { "filter[search_company]":str, "filter[region_id]":region_id},function(data){

                                var list = JSON.parse(data)['data'];

                                suggest_count = list.length;
                                console.log(suggest_count);
                                if(suggest_count > 0){
                                    $('#'+field_id+'_wrapper').html("").show();
                                    for(var i in list){

                                        if(list[i] != ''){
                                            var list_id = list[i].id;
                                            $('#'+field_id+'_wrapper').append('<div class="variant" data-key="'+i+'" id="result_id-'+list_id+'">'+list[i].name+' '+list[i].locality+' '+list[i].region_id+'</div>');

                                            $('#'+field_id+'_wrapper').find('#result_id-'+list_id).click(function() {
                                                document.getElementById(field_id).value = list[$(this).data('key')].name;
                                                document.getElementById(field_second).value = list[$(this).data('key')].id;
                                                $('#'+field_id+'_wrapper').fadeOut(2350).html('');
                                            });
                                        }
                                    }
                                }
                            }, 'html');
                        }
                        break;
                }
            })
        )


        .on('keydown', '.user_search_partner', (function(I){
                switch(I.keyCode) {
                    case 27: // escape
                        $('.search_wrapper').hide();
                        return false;
                        break;

                }
            })
        )

        .on('click', '.clear-search-partner', (function(I){
                $('#'+$(this)[0].dataset.fieldid).val('');
                $('#'+$(this)[0].dataset.secondfield).val('');

            })
        )

        .on('click', '.save_participant', function () {
            let form_id = $(this).data('form');
            let route = '/events/'+$(this).data('event')+'/participants/store';
            let form_data = new FormData(document.forms[form_id]);
            axios
                .post(route, form_data)
                .then((response) => { parseData(response.data);})
                .catch((error) => {alert(errors);});
        })

        .on('click', '.answer-add', function () {

            let list = $('#answers-list'),
                action = $(this).data('action');

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: action,
                type: 'GET',
                dataType: 'html',
                contentType: false,
                processData: false,
                success: function (response) {
                    list.append(response);
                },
            });
        })
        .on('click', '.presentation_slide-add', function () {

            let list = $('#presentation_slides-list'),
                action = $(this).data('action');

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                url: action,
                type: 'GET',
                dataType: 'html',
                contentType: false,
                processData: false,
                success: function (response) {
                    list.append(response);
                },
            });
        })
        .on('click', '.add-sms', (function () {
           let add_text=$(this).data('text');
            $('#sms_text').val(function(i, text) { return text + add_text;});
        }))
        .on('click', '#send_map_sms', (function () {
           let text=$('#sms_text').val();
           let phone=$('#phone').val();
            axios
                .post('/admin/tickets/send-sms',{"text" : text, "phone" : phone})

                .then((response) => {
                    alert('Сообщение отправлено')
                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('keyup', '.search_phone_user', (function(I){
                $('#phone-exists').addClass('d-none');
                let input_initial_value;
                switch(I.keyCode) {
                    // игнорируем нажатия
                    case 13:  // enter
                    case 27:  // escape
                    case 38:  // стрелка вверх
                    case 40:  // стрелка вниз
                        break;

                    default:
                        $(this).attr('autocomplete','off');

                        if($(this).val().length>14){

                            input_initial_value = $(this).val();
                            $.get("/api/phone-search", { "phone":$(this).val()},function(data){
                                var list = JSON.parse(data);
                                if(list['exists']){
                                    $('#phone-exists').removeClass('d-none');
                                    if(list['text']!="") {
                                        $('#phone-exists').html("Номер телефона уже зарегистрирован на сайте. " + list['text']);
                                    }
                                } else {
                                    $('#phone-exists').addClass('d-none');
                                }
                            }, 'html');
                        }
                        break;
                }
            })
        )
        .on('keyup', '.search_phone', (function(I){
                $('#phone-exists').addClass('d-none');
                let input_initial_value;
                switch(I.keyCode) {
                    // игнорируем нажатия
                    case 13:  // enter
                    case 27:  // escape
                    case 38:  // стрелка вверх
                    case 40:  // стрелка вниз
                        break;

                    default:
                        $(this).attr('autocomplete','off');

                        if($(this).val().length>14){

                            input_initial_value = $(this).val();
                            $.get("/api/phone-search", { "phone":$(this).val()},function(data){
                                var list = JSON.parse(data);
                                if(list['exists']){

                                    $('#phone-exists').removeClass('d-none');
                                    if(list['text']!="") {
                                        $('#phone-exists').html("Номер телефона уже зарегистрирован на сайте. " + list['text']);
                                    }
                                } else {
                                    $('#phone-exists').addClass('d-none');
                                }
                            }, 'html');
                        }
                        break;
                }
            })
        )
        .on('keyup', '.check_email_exists', (function(I){
                $('#email_exists').addClass('d-none');
                let input_initial_value;
                switch(I.keyCode) {
                    // игнорируем нажатия
                    case 13:  // enter
                    case 27:  // escape
                    case 38:  // стрелка вверх
                    case 40:  // стрелка вниз
                        break;

                    default:
                        $(this).attr('autocomplete','off');

                        if($(this).val().length>10){

                            input_initial_value = $(this).val();
                            $.get("/api/email-exists", { "email":$(this).val()},function(data){
                                var list = JSON.parse(data);
                                if(list['exists']){

                                    $('#email_exists').removeClass('d-none');
                                    if(list['text']!="") {
                                        $('#email_exists').html("Email уже зарегистрирован на сайте. " + list['text']);
                                    }
                                } else {
                                    $('#email_exists').addClass('d-none');
                                }
                            }, 'html');
                        }
                        break;
                }
            })
        )
        .on('dblclick', '.edited-select', (function () {
            let objecttype=$(this).data('objecttype');
            let objectid=$(this).data('objectid');
            let target=$(this).data('target');
            $(this).addClass('d-none');
            $('#'+target).parent().removeClass('d-none');

        }))
        .on('dblclick', '.edited-text', (function () {
            let value=$(this).text();
            let objecttype=$(this).data('objecttype');
            let fieldname=$(this).data('fieldname');
            let idsrc=$(this).attr('id');
            let objectid=$(this).data('objectid');
            $(this).addClass('d-none');
            $(this).parent().append('<div class="input-group"><input type="text" name="'+fieldname+'" id="'+fieldname+'-input"  class="form-control" value="'+value+'"><div class="input-group-append">\n' +
                '<div class="input-group-text edited-save" data-objecttype="'+objecttype+'" data-fieldname="'+fieldname+'" data-idsrc="'+idsrc+'" data-objectid="'+objectid+
                '"><i class="fa fa-save"></i></div></div></div></div>')

        }))
        .on('click', '.edited-save', (function () {
            let objecttype=$(this).data('objecttype');
            let fieldname=$(this).data('fieldname');

            let is_select=$(this).data('isselect');
            let idsrc=$(this).data('idsrc');
            let objectid=$(this).data('objectid');
            let value=$(this).data('value');

            if(typeof undefined === 'undefined') {
                value = $('#' + fieldname + '-input').val();
            }
            if(is_select==1) {
                value = $('#' + fieldname + '-select').find('option:selected').val();
            }
            if(typeof(value) === 'undefined') {
                value = $('#' + fieldname + '-input-' + objectid).val();
             }

            let route='';
            switch (objecttype) {
                case 'users':
                    route="/admin/users/update-field/"+objectid;
                    break;
                case 'user_fl':
                    route="/admin/user-fls/update-field/"+objectid;
                    break;
                case 'user_fl_relation':
                    route="/admin/user-fls/update-relations";
                    break;
                case 'user_crm_relation':
                    route="/admin/users/update-crm-relations";
                    break;
                case 'address':
                    route="/admin/addresses/update-field";
                    break;
                case 'tender':
                    route="/admin/tenders/update-field";
                    break;
                case 'manual_payment_results':
                    route="/admin/kpi-user-settings/manual-payments-results/update-field";
                    break;
                default:
                    alert( "Маршрута нет" );
            }

            axios
                .post(route, {"fieldname": fieldname, "objectid" : objectid, "value" : value})
                .then((response) => {

                    if(response.data['error']!== undefined) {
                        alert(response.data['error']);
                    } else if(response.data != 'error' && $(this).data('noupd') != '1') {
                            $("#" + idsrc).removeClass('d-none')
                            $("#" + idsrc).html(response.data)
                            if(is_select==1) {
                                $(this).parent().parent().addClass('d-none');
                            } else {
                                $(this).parent().parent().remove();
                            }

                        }


                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.save_user_prop', (function () {
            let prop_id=$(this).data('propId');
            let user_id=$(this).data('userId');
            let field=$(this).data('field');
            let is_select=$(this).data('isselect');
            let idsrc=$(this).data('idsrc');
            let idthis=$(this).data('idthis');
            let value=$('#' + prop_id + '-input').val();;

            if(is_select==1) {
                value = $('#service_area-select').find('option:selected').val();
            }


            let route='/admin/users/save-prop/'+user_id;

            axios
                .post(route, {"field": field, "prop_id" : prop_id, "value" : value})
                .then((response) => {

                    if(response.data != 'error') {

                        $("#" + idsrc).removeClass('d-none')
                        $("#" + idthis).addClass('d-none')
                        $("#" + idsrc).html(response.data)



                    }

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.add_event_member', (function () {
            let user_id=$(this).data('user');
            let route='/events/add-member'

            axios
                .post(route, {"user_id": user_id})
                .then((response) => {
                    parseData(response.data)

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.edit_contract_list', (function () {
            let contragent=$(this).data('contragent');
            let type=$(this).data('type');
            axios
                .post('/contracts/get-asc-form', {"contragent": contragent,"type":type})
                .then((response) => {
                    if(response.data != 'error') {
                        $("#contract_edit_row_" + contragent).removeClass('d-none');
                        $("#contract_edit_row_" + contragent).html(response.data);
                        $(".datetimepicker")
                            .datetimepicker({
                                locale: 'ru',
                                //format: 'L',
                                format: 'DD.MM.YYYY',
                                useCurrent: false,
                                pickTime: false
                            });
                    }

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.create_difficulty_contract_type', (function () {
            route="/admin/contract-types/create-difficulty";
            axios
                .get(route)
                .then((response) => {
                    if(response.data != 'error') {
                        parseData(response.data);
                        $('.datetimepicker').datetimepicker({ locale: 'ru', format: 'L', useCurrent: false });
                    }

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.create_distance_contract_type', (function () {
            route="/admin/contract-types/create-distance";
            axios
                .get(route)
                .then((response) => {
                    if(response.data != 'error') {
                        parseData(response.data);
                        $('.datetimepicker').datetimepicker({ locale: 'ru', format: 'L', useCurrent: false });
                    }

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '#add_manual_payment_result', (function () {
            let value=$('#value').val();
            let period_num=$('#period_num').val();
            let year=$('#year').val();
            let currency_id=$('#currency_id').val();
            let user_id=$('#users_search').find('option:selected').val();

            route="/admin/kpi-user-settings/manual-payments-results/add-field";
            axios
                .post(route, {"objectid" : user_id, "period_num": period_num, "year": year, "currency_id":currency_id, "value":value})
                .then((response) => {
                    if(response.data != 'error') {
                        $('#new_rows').append(response.data);
                    }

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('keyup', '.search-bik', (function(I){
            let suggest_count = 0, input_initial_value = '';
            var field_name = $(this)[0].dataset.fieldName;
            switch(I.keyCode) {
                // игнорируем нажатия
                case 13:  // enter
                case 27:  // escape
                case 38:  // стрелка вверх
                case 40:  // стрелка вниз
                    break;

                default:
                    $(this).attr('autocomplete','off');
                    $('#contragent_bik_wrapper').hide();
                    if($(this).val().length>6){

                        input_initial_value = $(this).val();
                        $.get("/api/dadata/bank", { "str":$(this).val() },function(data){
                            var list = JSON.parse(data);

                            suggest_count = list.length;
                            if(suggest_count > 0){
                                $('#contragent_bik_wrapper').html("").show();
                                for(var i in list){
                                    if(list[i] != ''){

                                        $('#contragent_bik_wrapper').append('<div class="variant" data-key="'+i+'" id="result_id-'+list[i].bic+'">'+list[i].bic+' '+list[i].name+'</div>');
                                        $('#contragent_bik_wrapper').find('#result_id-'+list[i].bic).click(function() {


                                            document.getElementById('contragent_ks').value = list[$(this)[0].getAttribute('data-key')].alldata.correspondent_account;
                                            document.getElementById('contragent_bik').value = list[$(this)[0].getAttribute('data-key')].alldata.bic;
                                            document.getElementById('contragent_bank').value = list[$(this)[0].getAttribute('data-key')].name;

                                            $('#contragent_bik_wrapper').fadeOut(2350).html('');
                                        });
                                    }
                                }
                            }
                        }, 'html');
                    }
                    break;
                }
            })
        ).on('keyup', '.search_tender_customer_locality', (function(I){
            let suggest_count = 0, input_initial_value = '';
            var field_name = $(this)[0].dataset.fieldName;
            let wrapper=$('#'+field_name+'_locality_wrapper');
            switch(I.keyCode) {
                // игнорируем нажатия
                case 13:  // enter
                case 27:  // escape
                case 38:  // стрелка вверх
                case 40:  // стрелка вниз
                    break;

                default:
                    $(this).attr('autocomplete','off');

                    if($(this).val().length>3){
                        input_initial_value = $(this).val();
                        $.get("/api/dadata/address", { "str":$(this).val() , "tobound":"settlement" },function(data){
                            var list = JSON.parse(data);
                            suggest_count = list.length;
                            if(suggest_count > 0){
                                wrapper.html("").show();
                                for(var i in list){
                                    if(list[i] != ''){
                                        wrapper.append('<div class="variant" data-key="'+i+'" id="result_id-'+list[i].id+'">'+list[i].name+'</div>');
                                        wrapper.find('#result_id-'+list[i].id).click(function() {

                                            if(list[$(this)[0].getAttribute('data-key')].alldata.city){
                                                document.getElementById(field_name+'_customer_locality').value = list[$(this)[0].getAttribute('data-key')].alldata.city;
                                            } else {
                                                document.getElementById(field_name+'_customer_locality').value = list[$(this)[0].getAttribute('data-key')].alldata.area_with_type;
                                            }
                                            //document.getElementById(field_name+'_region_id').value = list[$(this)[0].getAttribute('data-key')].alldata.region_iso_code;
                                            // прячем слой подсказки
                                            wrapper.fadeOut(2350).html('');
                                        });
                                    }
                                }
                            }
                        }, 'html');
                    }
                    break;
            }
        })).on('keyup', '.search_locality', (function(I){
            let suggest_count = 0, input_initial_value = '';
            let wrapper=$('#'+$(this).data('wrapper'));
            let region=$(this).data('regionField');

            let locality=$('#'+$(this).data('fieldName'));
            switch(I.keyCode) {
                // игнорируем нажатия
                case 13:  // enter
                case 27:  // escape
                case 38:  // стрелка вверх
                case 40:  // стрелка вниз
                    break;
                default:
                    $(this).attr('autocomplete','off');
                    if($(this).val().length>3){
                        input_initial_value = $(this).val();
                        $.get("/api/dadata/address", { "str":$(this).val() , "tobound":"settlement" },function(data){
                            var list = JSON.parse(data);
                            suggest_count = list.length;
                            if(suggest_count > 0){
                                wrapper.html("").show();
                                for(var i in list){
                                    if(list[i] != ''){
                                        wrapper.append('<div class="variant" data-key="'+i+'" id="result_id-'+list[i].id+'">'+list[i].name+'</div>');
                                        wrapper.find('#result_id-'+list[i].id).click(function() {
                                            let alldata=list[$(this)[0].getAttribute('data-key')].alldata;

                                            if(alldata.city){
                                                locality.val(alldata.city_with_type);
                                            } else {
                                                locality.val(alldata.area_with_type);
                                            }
                                            let region_id=alldata.region_iso_code;

                                            $('#'+region+' option[value=\''+region_id+'\']').attr('selected', 'selected');
                                            // прячем слой подсказки
                                            wrapper.fadeOut(2350).html('');
                                        });
                                    }
                                }
                            }
                        }, 'html');
                    }
                    break;
            }
        }))
        .on('keyup', '.search_street', (function(I){
            let suggest_count = 0, input_initial_value = '';
            let wrapper=$('#'+$(this).data('wrapper'));
            console.log($(this).data('wrapper'));
            let street=$('#'+$(this).data('fieldName'));

            let filterRegion=$('#'+$(this).data('regionField')).find('option:selected').text();
            if(filterRegion == undefined){
                filterRegion='';
            }else{
                filterRegion=filterRegion+' ';
            }
            let filterLocality=$('#'+$(this).data('localityField')).val();
            if(filterLocality == undefined){
                filterLocality='';
            }else{
                filterLocality=filterLocality+' ';
            }
            switch(I.keyCode) {
                // игнорируем нажатия
                case 13:  // enter
                case 27:  // escape
                case 38:  // стрелка вверх
                case 40:  // стрелка вниз
                    break;
                default:
                    $(this).attr('autocomplete','off');
                    if($(this).val().length>3){
                        input_initial_value = $(this).val();
                        $.get("/api/dadata/address", { "str":filterRegion+' '+ filterLocality+' '+ $(this).val() , "frombound":"street", "tobound":"street" },function(data){
                            var list = JSON.parse(data);
                            suggest_count = list.length;
                            if(suggest_count > 0){
                                wrapper.html("").show();
                                for(var i in list){
                                    if(list[i] != ''){
                                        wrapper.append('<div class="variant" data-key="'+i+'" id="result_id-'+list[i].id+'">'+list[i].name+'</div>');
                                        wrapper.find('#result_id-'+list[i].id).click(function() {
                                            let alldata=list[$(this)[0].getAttribute('data-key')].alldata;
                                            if(alldata.street_with_type){
                                                street.val(alldata.street_with_type);
                                            } else {
                                                street.val(alldata.street_with_type);
                                            }
                                            wrapper.fadeOut(2350).html('');
                                        });
                                    }
                                }
                            }
                        }, 'html');
                    }
                    break;
            }
        }))
        .on('keyup', '.customers', (function(I){
                var field_name = $(this)[0].dataset.fieldName;
                let suggest_count = 0, input_initial_value = '';
                switch(I.keyCode) {
                    // игнорируем нажатия
                    case 13:  // enter
                    case 27:  // escape
                    case 38:  // стрелка вверх
                    case 40:  // стрелка вниз
                        break;
                    default:
                        $(this).attr('autocomplete','off');

                        if($(this).val().length>2){
                            input_initial_value = $(this).val();
                            $.get("/api/customer-search", { "filter[search_customer]":$(this).val()},function(data){
                                var list = JSON.parse(data);
                                suggest_count = list.data.length;
                                $('#' + field_name+'_wrapper').hide();
                                if(suggest_count > 0){

                                    $('#' + field_name+'_wrapper').html("").show();
                                    for(var i in list.data){
                                        if(list.data[i] != ''){

                                            $('#' + field_name+'_wrapper').append('<div class="variant" data-key="'+i+'" id="result_id-'+list.data[i].id+'">'+list.data[i].name+'</div>');
                                            $('#' + field_name+'_wrapper').find('#result_id-'+list.data[i].id).click(function() {
                                                    $('.'+ field_name+'_contact').val('');
                                                    $('.'+ field_name+'_customer').val('');

                                                for(var i in list.data[$(this)[0].getAttribute('data-key')]){
                                                    $('#' + field_name+'_customer_'+i).val('');
                                                    $('#' + field_name+'_customer_'+i).val(list.data[$(this)[0].getAttribute('data-key')][i]);
                                                }

                                                for(var i in list.data[$(this)[0].getAttribute('data-key')].contact){
                                                    $('#' + field_name+'_contact_'+i).val('');
                                                    $('#' + field_name+'_contact_'+i).val(list.data[$(this)[0].getAttribute('data-key')].contact[i]);
                                                }

                                                document.querySelector('#' + field_name+'_contact_lpr').checked=false;
                                                if(list.data[$(this)[0].getAttribute('data-key')].contact.lpr == 1) document.querySelector('#' + field_name+'_contact_lpr').checked=true;

                                                $('#' + field_name+'_wrapper').fadeOut(2350).html('');
                                            });
                                        } else {
                                            $('#' + field_name+'_wrapper').html("").hide();
                                        }
                                    }
                                }
                            }, 'html');
                        }
                        break;
                }
            }))
        .on('change','.authorization_type',(function (I) {
                if($(this).is(':checked')) {
                    $('#authorisation_roles_' + $(this).data('roleName')).removeClass('d-none');
                }
                else {
                    $('#authorisation_roles_' + $(this).data('roleName')).addClass('d-none');
                }
        }))


        .on('keydown', '.customers', (function(I){
                var field_name = $(this)[0].dataset.fieldName;
                switch(I.keyCode) {
                    case 27: // escape
                        $('#' + field_name+'_wrapper').hide();
                        return false;
                        break;

                }
            })
        )
        .on('click', '.tender-customer-store-field', (function(I){

            var field_name = $(this)[0].dataset.fieldName;
            var form_id = $(this)[0].dataset.formId;

            var customer = {customer: {"name" : $('#' + form_id+'_customer_name').val(),
                    "id" : $('#' + form_id+'_customer_id').val(),
                    "locality" : $('#' + form_id+'_customer_locality').val(),
                    "region_id" : $('#' + form_id+'_customer_region_id').val(),
                    "phone" : $('#' + form_id+'_customer_phone').val(),
                    "email" : $('#' + form_id+'_customer_email').val(),
                    "role_name" : $('#' + form_id+'_role_name').val(),
                    "tender_id" : $('#tender_id').val()
                },
                contact: {

                    "last_name" : $('#' + form_id+'_contact_last_name').val(),
                    "first_name" : $('#' + form_id+'_contact_first_name').val(),
                    "middle_name" : $('#' + form_id+'_contact_middle_name').val(),
                    "position" : $('#' + form_id+'_contact_position').val(),
                    "phone" : $('#' + form_id+'_contact_phone').val(),
                    "email" : $('#' + form_id+'_contact_email').val(),
                    "role_type_id" : $('#' + form_id+'_contact_role_type_id').val(),
                    "lpr" : document.querySelector('#' + form_id+'_contact_lpr').checked,
                    "id" : $('#' + form_id+'_contact_id').val()
                },
                "form_id" :form_id};

            axios
                .post("/api/customer-store", customer)

                .then((response) => {

                    $('#' + form_id+'_customer_id').val(response.data['customer']['id']);
                    if(response.data['contact']) {$('#' + form_id+'_contact_id').val(response.data['contact']['id']);}

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.add-tender-customer', (function(I){
            var field_name = $(this)[0].dataset.fieldName;
            let field = $('#'+field_name);
            axios
                .get("/api/customer-create/" + field_name)
                .then((response) => {
                    $("#customers").append(response.data);
                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.phone-save', (function () {
            let phoneableid=$(this).data('phoneableid');
            let phoneabletype=$(this).data('phoneabletype');
            let phoneblock=$(this).data('phoneblock');
            let number=$('#number').val();
            let extra=$('#extra').val();
            let comment=$('#new_phone_comment').val();


            axios
                .post('/phones/add', {"phoneable_id": phoneableid, "phoneable_type" : phoneabletype, "number" : number, "extra" : extra, "comment" : comment})
                .then((response) => {
                    $("#"+phoneblock).removeClass('d-none');

                    $("#"+phoneblock).append(response.data);
                    $("#new-phone").addClass('d-none');



                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.phone-delete', (function () {
            let objectid=$(this).data('objectid');

            axios
                .delete('/phones/'+objectid)
                .then((response) => {
                    $(this).parent().remove();
                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.detach-fl-relation-type', (function () {
            let relationid=$(this).data('relationid');
            let relationtype=$(this).data('relationtype');

            axios
                .delete('/admin/users/detach-fl-relation-type/'+relationid+'?relationtype='+relationtype)
                .then((response) => {
                    $(this).parent().remove();
                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.detach-crm-relation-type', (function () {
            let relationid=$(this).data('relationid');
            let relationtype=$(this).data('relationtype');

            axios
                .delete('/admin/users/detach-crm-relation-type/'+relationid+'?relationtype='+relationtype)
                .then((response) => {
                    $(this).parent().remove();
                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.edited-region-locality-save', (function () {
            let objecttype=$(this).data('objecttype');
            let objectid=$(this).data('objectid');
            let regionid=$('#region_id-input').val();
            let locality=$('#locality-input').val();
            let route='';
            switch (objecttype) {
                case 'user_fl':
                    route="/admin/user-fls/update-region-locality/"+objectid;
                    break;
                default:
                    alert( "Маршрута нет" );
            }

            axios
                .post(route, {"objectid" : objectid, "regionid" : regionid, "locality" : locality})
                .then((response) => {
                    $("#region_locality").removeClass('d-none')
                    $("#region_locality").html(response.data['region_name']+', '+response.data['locality'])
                    $("#region_locality").data('regionid',response.data['region_id']);
                    $("#region_locality").data('locality',response.data['locality']);
                    $(this).parent().parent().remove();


                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.edited-text-region-locality', (function () {
            let objecttype=$(this).data('objecttype');
            let objectid=$(this).data('objectid');
            let regionid=$(this).data('regionid');
            let locality=$(this).data('locality');

            let route='/addresses/edit-region-locality?objecttype='+objecttype+'&objectid='+objectid+'&regionid='+regionid+'&locality='+locality;
            axios
                .get(route)
                .then((response) => {
                    $(this).addClass('d-none');
                    $(this).parent().append(response.data)


                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });

        }))
        .on('click', '.show-window', (function () {
            window.scrollTo(0,240);
            $('.windows').fadeOut(200);
            setTimeout(() => {  $("#"+$(this).data('window')).fadeIn(300); }, 250);



        }))
        .on('click', '.relation-btn', (function () {
            axios
                .post("/admin/user-fls/update-relations", {"parent_user_id": $(this).data('parentid'), "child_user_fl_id" : $(this).data('childflid'), "parent_user_fl_id" : $(this).data('parentflid'), "child_user_id" : $(this).data('childid'), "relation_id_crm" : $(this).data('relationcrm'), "relation_id" : $(this).data('relation'), "operation" : $(this).data('operation'), "srcid" : $(this).data('srcid')})
                .then((response) => {
                    parseData(response.data);

                })
                .catch((error) => {
                    this.status = 'Error:' + error;
                });
            if($(this).data('replacesecondary') != undefined) {
                $('#'+$(this).data('replacesecondary')).html($(this).data('textdata'))
            }

        }))
        .on('click', '.expand', (function () {
            $(this).hide();
            $("#"+$(this).data('block')).show();

        }))
        .on('dblclick', '.expanded', (function () {
            $(this).hide();
            $("#"+$(this).data('block')).show();

        }))
        
        
        .on('click', '.get-datasheet-tab', function () {
        
            $('.nav-link').removeClass('show active');
            $('.tab-pane').removeClass('show active');
            $('#datasheet-tab').addClass('show active');       
            $('#datasheet').addClass('show active');       
            
        })
        
        .on('keypress', ".cart-item input[type='number']", function (e) {

            if (e.which === 13) {
                let _this = this,
                    form = $(_this).parent('form'),
                    number = form.find('input[type="number"]'),
                    quantity = parseInt(number.val());
                if (quantity < 1) {
                    quantity = 1;
                } else if (quantity > parseInt(number.attr('max'))) {
                    quantity = parseInt(number.attr('max'));
                }
                number.val(quantity);
                submitForm(form);
                e.preventDefault();
            }
        })
        .on('click', ".cart-item .qty-btn", function (e) {
            e.preventDefault();
            let _this = this,
                form = $(_this).parent('form'),
                number = form.find('input[type="number"]'),
                quantity = parseInt(number.val())
            ;
            if ($(_this).hasClass('btn-minus')) {
                if (quantity > 1) {
                    quantity--;
                }
            }
            if ($(_this).hasClass('btn-plus')) {
                if (quantity < parseInt(number.attr('max'))) {
                    quantity++;

                }
            }

            number.val(quantity);

            submitForm(form);
        })
        .on('click', ".add-to-cart", function (e) {
            e.preventDefault();
            let _this = this, form = $(_this).parents('form');
            submitForm(form, function () {
                addToCartModal.find('.modal-body').html(form.data('name'));
                addToCartModal.modal('show');
            });
        })
        .on('click', '.add-cart-zip', function () {

            let route = '/cart/add-list';
            let product_id=$(this).data('product');
            axios
                .post(route, {"product_id":product_id,"quantity":1})
                .then((response) => {
                    parseData(response.data);
                    $(this).parent().find('.small-notice').fadeIn(500, function(){
                        setTimeout(function(){
                            $('.small-notice').fadeOut(2000);
                        }, 500);
                    });
                })
                .catch((error) => {

                });
        })

        .on('click', '.light-box-prev', function () {
            plusSlides(-1)
        })
        .on('click', '.light-box-next', function () {
            plusSlides(1)
        })
        .on('click', '.light-box-close', function () {
            closeModal($(this).data('id'))
        })
        .on('click', '.demo', function () {
            currentSlide($(this).data('id'), $(this).data('number'))
        })
        .on('click', '.hover-shadow', function () {
            openModal($(this).data('id'));
            currentSlide($(this).data('id'), $(this).data('number'))
        }).on('click', '.props_id_many_select', (function(){
            let propValueId=$(this).data('propValueId');
            let propId='props_id_many';
            if($(this).data('propId') != undefined){
                propId=$(this).data('propId');
            }
            $(this).parent().append('<input type="hidden" id="selected-prop-'+propId+'-'+propValueId+'" name="'+propId+'['+ propValueId +']">');
            $(this).addClass('props_id_many_selected');
            $(this).removeClass('props_id_many_select');
        }))
        .on('click', '.props_id_many_selected', (function(){
            let propValueId=$(this).data('propValueId');
            let propId='props_id_many';
            if($(this).data('propId') != undefined){
                propId=$(this).data('propId');
            }
            $('#selected-prop-'+propId+'-'+propValueId).remove();
            $(this).removeClass('props_id_many_selected');
            $(this).addClass('props_id_many_select');
        }));
    // Open the Modal
    function openModal(id) {
        $('.light-box-' + id).show();
    }

    // Close the Modal
    function closeModal(id) {
        $('.light-box-' + id).hide();
    }

    let slideIndex = 1;
    //showSlides(slideIndex);

    // Next/previous controls
    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    // Thumbnail image controls
    function currentSlide(id, n) {
        showSlides(id, slideIndex = n);
    }

    function showSlides(id, n) {
        let i;
        let slides = $('.mySlides-' + id);
        let dots = $('.light-box-' + id + ' .demo');
        let captionText = $('.light-box-' + id + ' .light-box-caption');
        if (n > slides.length) {
            slideIndex = 1
        }
        if (n < 1) {
            slideIndex = slides.length
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex - 1].style.display = "block";
        dots[slideIndex - 1].className += " active";
        captionText.innerHTML = dots[slideIndex - 1].alt;
    }


    btnOk.on('click', function () {
        let form = $('#form-content');
        if (form !== undefined) {
            submitForm(form, function () {
                $(_modal).modal('hide');
            });
        }
    });

    function parseData(data, callback) {
        if ("alert" in data) {
            alert(data.alert);
        }
        if ("show" in data) {

            $.each(data.show, function (index, identifier) {
                $(identifier).show().removeClass('d-none');
            });
        }
        if ("hide" in data) {
            $.each(data.hide, function (index, identifier) {
                $(identifier).hide();
            });
        }
        if ("append" in data) {

            $.each(data.append, function (identifier, view) {
                $(identifier).append(view);
            });
        }
        if ("remove" in data) {
            $.each(data.remove, function (index, identifier) {
                $(identifier).remove();
            });
        }


        if ("replace" in data) {
            $.each(data.replace, function (identifier, view) {
                $(identifier).replaceWith(view);
            });
        }



        if ("prepend" in data) {
            $.each(data.prepend, function (identifier, view) {
                $(identifier).prepend(view);
            });
        }

        if ("update" in data) {
            $.each(data.update, function (identifier, view) {
                $(identifier).html(view);
            });
        }
        if ("add_class" in data) {
            $.each(data.add_class, function (identifier, view) {
                $(identifier).addClass(view);
            });
        }
        if ("remove_class" in data) {
            $.each(data.remove_class, function (identifier, view) {
                $(identifier).removeClass(view);
            });
        }

        if ("values" in data) {
            $.each(data.values, function (identifier, value) {
                $(identifier).val(value);
            });
        }
        if ("attr" in data) {
            $.each(data.attr, function (identifier, attributes) {
                $.each(attributes, function (attribute, value) {
                    $(identifier).attr(attribute, value);
                });
            });
        }
        if ("datetimepicker" in data) {

            $(".datetimepicker")
                .datetimepicker({
                    locale: 'ru',
                    //format: 'L',
                    format: 'DD.MM.YYYY',
                    useCurrent: false,
                    pickTime: false
                });
        }
        if ("mask_phones" in data) {
            mask_phones();
        }

        if ("alert_top_right" in data) {

            $("#alert_top_right").append('<span class="msg-t '+data.style+'">'+data.msg+'</span>');
            $("#alert_top_right").fadeIn(500, function(){
                setTimeout(function(){
                    $("#alert_top_right").fadeOut(2000);
                }, 4000);
                setTimeout(function(){
                    $("#alert_top_right").html('');
                }, 6000);
            });
            //$(".tmp-msg").remove();
        }

        if ("redirect" in data) {
            document.location.href = data.redirect;
        } else if ("refresh" in data) {
            document.location.reload();
        } else if ("close_modal" in data) {
            $(_modal).modal('hide');
        } else if ("small_notice_btn" in data) {

            $("#"+data.btn).append('<span class="text-08 tmp-msg text-success">'+data.msg+'</span>');
            $(".tmp-msg").fadeIn(1000, function(){
                setTimeout(function(){
                    $(".tmp-msg").fadeOut(2000).remove();
                }, 2000);
            });
            //$(".tmp-msg").remove();
        }else if ("big_notice_btn" in data) {

            $("#"+data.btn).append('<span class="tmp-msg '+data.style+'">'+data.msg+'</span>');
            $(".tmp-msg").fadeIn(2000, function(){
                setTimeout(function(){
                    $(".tmp-msg").fadeOut(3000).remove();

                }, 4000);
            });
            //$(".tmp-msg").remove();
        } else {


            if (callback !== undefined) {
                callback();
            }

            $('[data-toggle="popover"]').popover();
            mask_phones();
        }
    }

    function submitForm(form, callback) {
        $('[data-toggle="popover"]').popover('hide');

        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            dataType: 'json',
            data: form.serializeArray() || [],
            error: function (xhr, status, error) {
                //console.log(xhr.responseJSON.errors);
                if ("errors" in xhr.responseJSON) {

                    $("#form-content")
                        .find('.form-control')
                        .removeClass('is-invalid')
                        .next()
                        .html('');
                    let parse_name = function (name) {
                        if (~name.indexOf(".")) {
                            let names = name.split('.');
                            return names.shift() + "[" + names.join("][") + "]"
                        }
                        return name;
                    };
                    $.each(xhr.responseJSON.errors, function (name, error) {
                        let element = $('#form-content').find('[name="' + parse_name(name) + '"]');
                        element.addClass('is-invalid').next().html(error);
                    });
                }
            },
            success: function (data) {
                parseData(data, callback);
                //$('.toast.newest').toast('show').removeClass('newest');
                $('#form-modal').modal('hide');
            }
        });
    }

	    // Custom Aditon Script =================

    var $siteForm = $( '.js-siteForm' ).length ? $( '.js-siteForm' ) : null,
        $openSiteForm = $( '.js-siteFormOpen' ).length ? $( '.js-siteFormOpen' ) : null,
        $closeSiteForm = $( '.js-siteFormClose' ).length ? $( '.js-siteFormClose' ) : null,
        $videoCarousel = $( '.js-videoBlock' ).length ? $( '.js-videoBlock' ) : null,
        siteFormClassName = 'open';

    if( $siteForm ) {

      $(document).ready( function() {
        setTimeout( function() {
          $siteForm.addClass( siteFormClassName );
            setTimeout( function() {
                $siteForm.removeClass( siteFormClassName )
            }, 5000 );
        }, 1000 );
      } );

      if( $openSiteForm ) {
        $openSiteForm.on( 'click', function( e ) {
          e.preventDefault();
          $siteForm.addClass( siteFormClassName );
          return false;
        } );
      }

      if( $closeSiteForm ) {
        $closeSiteForm.on( 'click', function( e ) {
          e.preventDefault();
          $siteForm.removeClass( siteFormClassName );
          return false;
        } );
      }

    }

    if( $videoCarousel ) {
      $videoCarousel.owlCarousel({
        items: 1,
        autoplay: true,
        loop: false,
        autoplayTimeout: 15000,
        autoplayHoverPause: true,
        nav: false,
        dots: true,
        touchDrag: true,
        smartSpeed: 500,

      });
    }
	
	 // var $videoCarousel = $( '.js-videoBlock' ).length ? $( '.js-videoBlock' ) : null;
  
	 var $categoryTabs = $( '.js-categoryTabs li' ).length ? $( '.js-categoryTabs li' ) : null,
      $categoryList = $( '.js-categoryList' ).length ? $( '.js-categoryList' ) : null,
      $tabGroupHeader = $( '.js-tabGroupHeader' ).length ? $( '.js-tabGroupHeader' ) : null,
      $activeClass = 'active',
      $openClass = 'is-open';

  function checkElems( $elems, $index ) {

    $elems.each( function() {
      if( $(this).attr( 'data-slider-index' ) == $index ) {
        $(this).show();
      }else {
        $(this).hide();
      }
    } );

  }

  if( $categoryTabs && $categoryList ) {

    $categoryTabs.first().addClass( $activeClass );

    $categoryTabs.on( 'click', function() {
      var $elemIndex = $( this ).index();

      $(this).addClass( 'active' ).siblings().removeClass( $activeClass );
      
      $categoryList.removeClass( $openClass ).eq( $elemIndex ).addClass( $openClass );
        
      checkElems( $( '.arrows-container .owl-arrow' ), $elemIndex );

    } );

    // Tab group
    if ($tabGroupHeader) {

            $tabGroupHeader.on('click', function () {
                var $elemIndex = $(this).data('groupIndex');
                
                $tabGroupHeader.not($(this)).removeClass($activeClass);

                $('.arrows-container').removeClass('d-block');
                $(this).toggleClass('active');
                
                if($(this).hasClass('active')){
                    $($(this).parent().find('.arrows-container')[0]).toggleClass('d-block')
                }
                

                checkElems($('.arrows-container .owl-arrow'), $elemIndex);
            });
        }


    $categoryList.each( function( index ) {

      var owl = $(this);

      $(this).attr( 'data-slider-index', index);

      $(this).owlCarousel({
        items: 1,
        nav: true,
        dots: false,
		autoplay:true,
		autoplayTimeout:7000,
		autoplaySpeed: 1500,
		autoplayHoverPause: true,
		slideBy: 1, 
		rewind: false,
		margin: 0,
        navText: ["<img src='images/sl-left.png'>","<img src='images/sl-right.png'>"],
        center: true,
        navClass: ['owl-next owl-arrow owl-arrow-' + index, 'owl-prev owl-arrow owl-arrow-' + index],
        navContainer: $( '.arrows-container' ),
        onInitialized: owlCarouselInitialized,
        responsive : {
          // breakpoint from 480 up
          480: {
            items: 1,
			autoplayTimeout:19000,
          },
          // breakpoint from 768 up
          768: {
            items: 4,
			autoplayTimeout:9000,
            center: false,
			loop: false,
          },
          1024: {
            items: 5,
			autoplayTimeout:9000,
            center: false,
          }
        }

      });

      function owlCarouselInitialized(e){
          var $elemParent = $( e.target ).parents( '.tab-group' ).hasClass( $openClass ) ? $( e.target ).parents( '.tab-group' ).index() : null;
          var $arrows = $( '.arrows-container .owl-arrow' );

          $arrows.each( function() {
            var $class = $(this).attr( 'class' ),
                $number = $class.replace(/\D/g, '');
            $(this).attr( 'data-slider-index', $number );
          } );

          $( '.arrows-container .owl-arrow' ).hide();
          $( '.arrows-container .owl-arrow[data-slider-index="0"]' ).show();
      }

    } );
  }



    // =================
	
	
    $('[data-toggle="popover"]').popover();
    mask_phones();
//    $('.toast').toast({});

})(jQuery);
